import React from "react";
import PropTypes from "prop-types";
import { Table } from "semantic-ui-react";
import CustomInput from "../../../CustomInput";
import BotonBorrar from "../../../botones/BotonBorrar";

class ContactosRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nombre: this.props.contacto.nombre,
      cargo: this.props.contacto.cargo,
      correo: this.props.contacto.correo,
      telefono: this.props.contacto.telefono
    };
  }

  handleInputChange = data => {
    if (this.props.editable) {
      this.setState({ [data.name]: data.value });
      this.props.handleChange(data);
    }
  };

  render() {
    return (
      <Table.Row>
        <Table.Cell>
          <CustomInput
            name="nombre"
            disabled={!this.props.editable}
            transparent
            placeholder="..."
            value={this.state.nombre}
            onChange={value =>
              this.handleInputChange({
                ...value,
                id_contacto: this.props.contactoID
              })
            }
          />
        </Table.Cell>
        <Table.Cell>
          <CustomInput
            name="cargo"
            disabled={!this.props.editable}
            transparent
            placeholder="..."
            value={this.state.cargo}
            onChange={value =>
              this.handleInputChange({
                ...value,
                id_contacto: this.props.contactoID
              })
            }
          />
        </Table.Cell>
        <Table.Cell>
          <CustomInput
            name="correo"
            disabled={!this.props.editable}
            transparent
            placeholder="..."
            value={this.state.correo}
            onChange={value =>
              this.handleInputChange({
                ...value,
                id_contacto: this.props.contactoID
              })
            }
          />
        </Table.Cell>
        <Table.Cell>
          <CustomInput
            name="telefono"
            disabled={!this.props.editable}
            transparent
            placeholder="..."
            value={this.state.telefono}
            onChange={value =>
              this.handleInputChange({
                ...value,
                id_contacto: this.props.contactoID
              })
            }
          />
        </Table.Cell>
        {this.props.editable && (
          <Table.Cell>
            <BotonBorrar
              data={this.props.contactoID}
              handleClick={this.props.borraContacto}
              headerText={`Eliminar Contacto`}
              content={`¿Desea eliminar a ${
                this.props.contacto.nombre
              } de la lista de contactos?`}
            />
          </Table.Cell>
        )}
      </Table.Row>
    );
  }
}

ContactosRow.propTypes = {
  contacto: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  handleChange: PropTypes.func,
  borraContacto: PropTypes.func
};

ContactosRow.defaultProps = {
  editable: false
};

export default ContactosRow;



// WEBPACK FOOTER //
// ./src/pages/shared/colegios/colegioForm/contactosTabla/ContactosRow.jsx